module.exports = __webpack_public_path__ + "img/payez-avec-Apaym-02.4da9cc56.png";